/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_PhoneInputs */

const en_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const de_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const fr_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telephone`)
};

const es_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefono`)
};

const it_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefono`)
};

const nl_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefoon`)
};

const pl_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const fi_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puhelin`)
};

const da_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const sv_resume_editor_phone = /** @type {(inputs: Resume_Editor_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Resume_Editor_PhoneInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_phone = /** @type {((inputs?: Resume_Editor_PhoneInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_PhoneInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_phone(inputs)
	if (locale === "fr") return fr_resume_editor_phone(inputs)
	if (locale === "es") return es_resume_editor_phone(inputs)
	if (locale === "it") return it_resume_editor_phone(inputs)
	if (locale === "nl") return nl_resume_editor_phone(inputs)
	if (locale === "pl") return pl_resume_editor_phone(inputs)
	if (locale === "fi") return fi_resume_editor_phone(inputs)
	if (locale === "da") return da_resume_editor_phone(inputs)
	if (locale === "sv") return sv_resume_editor_phone(inputs)
	return en_resume_editor_phone(inputs)
});